import { Form, Formik } from 'formik'
import ProductSkuFilterField from 'domains/product/organisms/sku-filter-field/product-sku-filter-field'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { LoaderButton } from 'components/molecules'
import PropTypes from 'prop-types'
import ProductPerPageFilterField from 'domains/product/organisms/paging-filter-field/product-per-page-filter-field'

const propTypes = {
  initialFilters        : PropTypes.object,
  perPage               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func,
  handleSubmitForm      : PropTypes.func.isRequired
}

const defaultProps = {
  initialFilters        : {},
  per_page              : '10',
  handlePerPageOnChange : () => { },
  handleSubmitForm      : () => { }
}

const BulkDiscountFilterForm = ({
  initialFilters,
  perPage,
  handlePerPageOnChange,
  handleSubmitForm
}) => {
  const initialValues = {
    sku      : initialFilters?.sku || '',
    per_page : initialFilters.per_page
  }

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ handleSubmitForm }
      enableReinitialize={ true }
    >
      {
        (formik) => (
          <Form>
            <ListGroup>
              <ListGroupItem className='p-2'>
                <ProductSkuFilterField />
              </ListGroupItem>
              <ListGroupItem>
                <ProductPerPageFilterField
                  perPage={ perPage }
                  handlePerPageOnChange={ handlePerPageOnChange }
                />
              </ListGroupItem>

              <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
                <LoaderButton
                  className='float-right'
                  color='primary'
                  type='submit'
                  disabled={ formik.isSubmitting }
                  isLoading={ formik.isSubmitting }
                  text={ 'SEARCH' }
                />
              </div>

            </ListGroup>
          </Form>
        )
      }

    </Formik>
  )
}

BulkDiscountFilterForm.propTypes    = propTypes
BulkDiscountFilterForm.defaultProps = defaultProps

export default BulkDiscountFilterForm
